import { createReducer } from '@reduxjs/toolkit'

import { KpiVariableOption } from 'types/GlobalCompanyGroups'

import * as kpiVariableActions from '../../actions/KpiVariables/actions'
import * as kpiVariableOptionActions from '../../actions/KpiVariableOptions/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export interface KpiVariableOptionReducerType {
  data: KpiVariableOption[]
  fetched: boolean
}

// Initial state
const INITIAL_STATE: KpiVariableOptionReducerType = {
  data: [],
  fetched: false
}

// Reducer
export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(kpiVariableOptionActions.getAllSuccess, (state, action) => {
      state.data = action.payload
      state.fetched = true
    })
    .addCase(kpiVariableActions.createSuccess, (state, action) => {
      const economySets = new Set<string | null>()

      state.data.forEach((option) => {
        economySets.add(option.economy_set_id)
      })

      const newOptions = Array.from(economySets).map((setId) => ({
        economy_set_id: setId,
        kpi_variable_id: action.payload.data.id,
        selected: [] as string[],
        parent_kpi_variable_id: action.payload.data.parent_kpi_variable_id
      }))

      state.data.push(...newOptions)
    })
    .addCase(kpiVariableOptionActions.updateSuccess, (state, action) => {
      const updatedOptions = action.payload

      const newOptions = updatedOptions.filter(
        (newOption) =>
          !state.data.find(
            (option) =>
              newOption.economy_set_id === option.economy_set_id &&
              newOption.kpi_variable_id === option.kpi_variable_id
          )
      )

      state.data = [
        ...state.data.map((option) => {
          const updatedOption = updatedOptions.find(
            (newOption) =>
              newOption.economy_set_id === option.economy_set_id &&
              newOption.kpi_variable_id === option.kpi_variable_id
          )

          return updatedOption ? updatedOption : option
        }),
        ...newOptions
      ]
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})
